// extracted by mini-css-extract-plugin
export var isPrintedCell = "_y2-1";
export var printerIcon = "_y2-0";